import { render, staticRenderFns } from "./err-detail.vue?vue&type=template&id=e81041ca&scoped=true&"
import script from "./err-detail.vue?vue&type=script&lang=ts&"
export * from "./err-detail.vue?vue&type=script&lang=ts&"
import style0 from "./err-detail.vue?vue&type=style&index=0&id=e81041ca&prod&lang=scss&"
import style1 from "./err-detail.vue?vue&type=style&index=1&id=e81041ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81041ca",
  null
  
)

export default component.exports